import { ActionFunction } from 'react-router-dom';
import { mutate } from '@oysterjs/core/graphql/actions';
import { client } from './client';
import {
  ClientCreateCertificateDocument,
  ClientCreateCertificateMutation,
  ClientCreateCertificateMutationVariables,
  CreateServiceRequestMutationVariables,
  CreateServiceRequestDocument,
  CreateServiceRequestMutation
} from './graphql';

export const clientCreateCertificate: ActionFunction = async ({ request }) =>
  mutate<ClientCreateCertificateMutation, ClientCreateCertificateMutationVariables>(client, {
    mutation: ClientCreateCertificateDocument,
    variables: {
      input: await request.json(),
      accountId: window.sessionStorage.getItem('_accountid') || ''
    }
  });

export const createServiceRequest: ActionFunction = async ({ request }) =>
  mutate<CreateServiceRequestMutation, CreateServiceRequestMutationVariables>(client, {
    mutation: CreateServiceRequestDocument,
    variables: {
      input: await request.json()
    }
  });
